export var serializeFloat = function serializeFloat(value) {
  if (value !== value) {
    return "NaN";
  }
  switch (value) {
    case Infinity:
      return "Infinity";
    case -Infinity:
      return "-Infinity";
    default:
      return value;
  }
};
export var serializeDateTime = function serializeDateTime(date) {
  return date.toISOString().replace(".000Z", "Z");
};